'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024 from "./scala.-I-Array$package$-I-Array$.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_SealedTrait(typeInfo, subtypes, annotations, typeAnnotations, isEnum, inheritedAnnotations) {
  this.k8 = null;
  this.iQ = null;
  this.sh = null;
  this.sk = null;
  this.sj = false;
  this.si = null;
  this.k8 = typeInfo;
  this.iQ = subtypes;
  this.sh = annotations;
  this.sk = typeAnnotations;
  this.sj = isEnum;
  this.si = inheritedAnnotations;
}
export { $c_Lmagnolia1_SealedTrait as $c_Lmagnolia1_SealedTrait };
$p = $c_Lmagnolia1_SealedTrait.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_SealedTrait;
/** @constructor */
function $h_Lmagnolia1_SealedTrait() {
}
export { $h_Lmagnolia1_SealedTrait as $h_Lmagnolia1_SealedTrait };
$h_Lmagnolia1_SealedTrait.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$f_T__hashCode__I("SealedTrait"));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.k8));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.iQ));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sh));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sk));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.sj ? 1231 : 1237));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.si));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 6);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmagnolia1_SealedTrait)) {
    if ((this.sj === x$0.sj)) {
      var x = this.k8;
      var x$2 = x$0.k8;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.iQ;
      var x$4 = x$0.iQ;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.sh, x$0.sh)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.sk, x$0.sk))) {
      return $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.si, x$0.si);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return 6;
});
$p.o = (function() {
  return "SealedTrait";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.k8;
      break;
    }
    case 1: {
      return this.iQ;
      break;
    }
    case 2: {
      return this.sh;
      break;
    }
    case 3: {
      return this.sk;
      break;
    }
    case 4: {
      return this.sj;
      break;
    }
    case 5: {
      return this.si;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.b = (function() {
  return (((("SealedTrait(" + this.k8) + ", IArray[") + $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_scala$002e$002dI$002dArray$0024package$0024$002dI$002dArray$0024.$m_s_IArray$package$IArray$().yg(this.iQ), "", ",", "")) + "])");
});
function $isArrayOf_Lmagnolia1_SealedTrait(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e5)));
}
export { $isArrayOf_Lmagnolia1_SealedTrait as $isArrayOf_Lmagnolia1_SealedTrait };
var $d_Lmagnolia1_SealedTrait = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_SealedTrait, "magnolia1.SealedTrait", ({
  e5: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lmagnolia1_SealedTrait as $d_Lmagnolia1_SealedTrait };
